import { ControlConfig, IControlConfigArgs } from "../../business-objects/control/control-config.model";

export interface IAclCategoryControlConfigArgs extends IControlConfigArgs {
    category: string;
}

const defaults = (): IAclCategoryControlConfigArgs => ({
    ...new ControlConfig(),
    category: ""
});

export class AclCategoryControlConfig extends ControlConfig {
    category: string;

    constructor(data?: IAclCategoryControlConfigArgs) {
        super({...defaults(), ...data});
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/acl-category-control-config.model.ts